// src/actions/actionTypes.js
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';